// extracted by mini-css-extract-plugin
export default {"wrapper":"JobPlacement_wrapper__W4w5J"};